import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import pt from 'vuetify/es5/locale/pt'

Vue.use(Vuetify)

export default new Vuetify({
  // theme: {
  // 	themes: {
  // 		light: {
  // 			primary: '#3f51b5',
  // 			secondary: '#b0bec5',
  // 			accent: '#8c9eff',
  // 			error: '#b71c1c',
  // 			iphColor: '#8d2021',
  // 			iphColor2: '#fbb4ff'
  // 		},
  // 	},
  // },
  lang: {
    locales: { pt },
    current: 'pt',
  },
  icons: {
    iconfont: 'mdi',
  },
})
